import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';
import { problemSection } from '../mockData';

const ProblemSection = () => {
  return (
    <section className="py-12 sm:py-16 bg-gradient-to-b from-white to-emerald-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Title */}
          <div className="text-center mb-8 sm:mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full mb-4">
              <AlertCircle className="h-8 w-8 text-amber-600" />
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-emerald-900">
              {problemSection.title}
            </h2>
          </div>

          {/* Problems Grid - Bigger Visual */}
          <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-10 border-t-4 border-amber-500">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
              {problemSection.problems.map((problem, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 p-4 sm:p-5 rounded-xl bg-emerald-50/50 hover:bg-emerald-50 hover:shadow-md transition-all duration-300 group border border-emerald-100"
                >
                  <div className="flex-shrink-0 bg-amber-500 p-2.5 rounded-full group-hover:scale-110 transition-transform duration-300">
                    <CheckCircle className="h-5 w-5 sm:h-6 sm:w-6 text-emerald-950" />
                  </div>
                  <p className="text-base sm:text-lg text-emerald-900 font-semibold leading-relaxed flex items-center">
                    {problem}
                  </p>
                </div>
              ))}
            </div>

            {/* Call to Action Text */}
            <div className="mt-8 pt-6 border-t border-emerald-200">
              <p className="text-center text-emerald-800 text-base sm:text-lg font-bold">
                💡 Jika anda menghadapi mana-mana masalah di atas, kami boleh membantu!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
